export default __webpack_public_path__ + "static/media/add-child-button-mobile.4a2b2060.png";